import React from 'react'

type Props = {
  /** Public path, e.g. "/falgar" or "/dack/pickup/dodge-ram". */
  path: string
}

/**
 * The canonical url for a page.
 *
 * Every category is reachable under both its Swedish url and the English route it rewrites
 * to, so each page has to name which one counts. Renders nothing without NEXT_PUBLIC_HOST,
 * since a canonical has to be absolute to mean anything.
 */
const SeoCanonical = ({ path }: Props) => {
  const host = process.env.NEXT_PUBLIC_HOST

  if (!host) return null

  return <link rel="canonical" href={`${host}${path}`} />
}

export default SeoCanonical
